import { api } from "./api";

const KEY = "guest_wishlist";

export function getGuestWishlist() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
}
function setGuestWishlist(ids) {
  try { localStorage.setItem(KEY, JSON.stringify([...new Set(ids)])); } catch {}
  window.dispatchEvent(new Event("wishlist-changed"));
}
export function isGuestWishlisted(id) {
  return getGuestWishlist().includes(id);
}
export function toggleGuestWishlist(id) {
  const ids = getGuestWishlist();
  if (ids.includes(id)) { setGuestWishlist(ids.filter((x) => x !== id)); return { action: "removed" }; }
  setGuestWishlist([...ids, id]); return { action: "added" };
}
export function clearGuestWishlist() {
  try { localStorage.removeItem(KEY); } catch {}
  window.dispatchEvent(new Event("wishlist-changed"));
}
export function guestWishlistCount() {
  return getGuestWishlist().length;
}

// Unified toggle: API when logged in, localStorage when guest
export async function toggleWishlist(id, isLoggedIn) {
  if (isLoggedIn) {
    const { data } = await api.post("/api/wishlist/toggle", { product_id: id, qty: 1 });
    return { action: data.action };
  }
  return toggleGuestWishlist(id);
}

// Merge guest list into the account after login/signup
export async function mergeGuestWishlistIntoAccount() {
  const ids = getGuestWishlist();
  if (!ids.length) return;
  let existing = [];
  try {
    const { data } = await api.get("/api/wishlist");
    existing = (data.items || []).map((p) => p.id);
  } catch {}
  for (const id of ids) {
    if (existing.includes(id)) continue;
    try { await api.post("/api/wishlist/toggle", { product_id: id, qty: 1 }); } catch {}
  }
  clearGuestWishlist();
}